import React from 'react';
import './SteelShaftSprocket.css';

function SteelShaftSprocket() {

    return  (
        <div className='sprocket-row'>
        <div className='sprocket-item'>
            <div className='sprocket-header'>TD-199-015</div>
            <div className='sprocket-subheader'>Steel D Shaft Sprocket</div>
            <div className='sprocket-subsubheader'>15 Teeth</div>
            <img src='/Images/TD-199-015.png' alt='TD-199-015' className='sprocket-image' />
        </div>

        <div className='sprocket-item'>
            <div className='sprocket-header'>TD-368-010</div>
            <div className='sprocket-subheader'>Steel D Shaft Sprocket</div>
            <div className='sprocket-subsubheader'>10 Teeth</div>
            <img src='/Images/TD-368-010.png' alt='TD-369-010' className='sprocket-image' />
        </div>

        <div className='sprocket-item'>
            <div className='sprocket-header'>TD-269-010</div>
            <div className='sprocket-subheader'>Steel D Shaft Sprocket</div>
            <div className='sprocket-subsubheader'>10 Teeth</div>
            <img src='/Images/TD-269-010.png' alt='TD-269-010' className='sprocket-image' />
        </div>
        </div>
    )
}

export default SteelShaftSprocket;
